import { SyntheticEvent } from "react";
import { DropdownProps } from "semantic-ui-react";
import Select, { SelectProps } from "../Select/Select";

import { usePropertyEditContext } from "../../../contexts/PropertyEditContext";

import { EditableFieldValue } from "../../../contexts/PropertyEditContext";

export interface PropertyFieldSelectProps extends Omit<SelectProps, "onChange"> {
	field: string;
	onChange: Function;
}

export default function PropertyFieldSelect({ field, onChange, search }: PropertyFieldSelectProps) {
	const editing = usePropertyEditContext();

	const options = editing[field].map((obj: EditableFieldValue) => {
		return {
			key: obj.value,
			text: obj.friendly,
			value: obj.value,
		};
	});

	// NB: Adapter to mimic event for consistency on bulk edit dialogs. Might be good to make this consistent everywhere.
	const selectChange = (_: SyntheticEvent<HTMLElement, Event>, data: DropdownProps) => {
		onChange({
			target: {
				value: data.value,
			},
		});
	};

	return <Select options={options} search={search} onChange={selectChange} />;
}
